import React, { useEffect, useState } from "react";
import "./MessageCodes.css";

const MessageA1Live = (props) => {
  const {
    item,
    // handleClick,
    // setTextOnClick,
    // setSubTextOnClick,
    // setGenesisUrl,
    setShowIframe,
    iframeRef,
    chatWithAgentClicked,
    setChatWithAgentClicked
  } = props;
  function sanitizeEncryptedString(input) {
    let cleaned = input.replace(/\\u003d/g, '=');
    if (cleaned.startsWith('=')) cleaned = cleaned.substring(1);
    return cleaned;
  }

  useEffect(() => {
    if (chatWithAgentClicked) {
      const url = sanitizeEncryptedString(item?.url);
      console.log(url, "Genesys URL A1live");
      if (iframeRef.current) {
        iframeRef.current.src = url;
        iframeRef.current.style.display = "block";
      }
      setShowIframe(true);
      setChatWithAgentClicked(false);
    }
  }, [chatWithAgentClicked, item?.url, iframeRef, setShowIframe, setChatWithAgentClicked]);

  return null;
};

export default MessageA1Live;
